import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Card, Col, message, Popconfirm, Row, Typography } from "antd";
import { postRequest } from "../../services/mainApp.service";

const transactionTypes = {
    POS: "POS",
    INVENTORY: "INV",
};

const RemoveTransactionData = () => {
    const controller = new window.AbortController();
    const userData = useSelector((state) => state.authReducer);
    const [loadingType, setLoadingType] = useState(null);

    useEffect(() => {
        return () => controller.abort();
    }, []);

    const handleRemoveData = async (transactionType) => {
        if (loadingType) return;

        const payload = {
            CompanyId: userData.CompanyId,
            TransactionType: transactionType,
        };

        setLoadingType(transactionType);
        try {
            const response = await postRequest("/RemoveTransactionData", payload, controller);

            if (response.error) {
                message.error(response.errorMessage || "Failed to remove transaction data");
                return;
            }

            if (response?.data?.response === false) {
                message.error(
                    response?.data?.DataSet?.Table?.errorMessage ||
                    response?.data?.Error_Message ||
                    "Failed to remove transaction data"
                );
                return;
            }

            message.success(response?.data?.Message || response?.successMessage || "Transaction data removed successfully");
        } catch (error) {
            if (error.message !== "canceled") {
                console.error("Error removing transaction data:", error);
                message.error("Failed to remove transaction data");
            }
        } finally {
            setLoadingType(null);
        }
    };

    return (
        <div>
            <Typography.Title level={3} style={{ color: "#4561B9", marginBottom: 16 }}>
                Remove Transaction Data
            </Typography.Title>

            <Card>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                        <Popconfirm
                            title="Remove POS Data"
                            description="Are you sure you want to remove POS transaction data?"
                            onConfirm={() => handleRemoveData(transactionTypes.POS)}
                            okText="Yes"
                            cancelText="No"
                            disabled={loadingType !== null}
                        >
                            <Button
                                type="primary"
                                danger
                                block
                                loading={loadingType === transactionTypes.POS}
                                disabled={loadingType !== null}
                            >
                                Remove Pos Data
                            </Button>
                        </Popconfirm>
                    </Col>

                    <Col xs={24} sm={12}>
                        <Popconfirm
                            title="Remove Inventory Data"
                            description="Are you sure you want to remove inventory transaction data?"
                            onConfirm={() => handleRemoveData(transactionTypes.INVENTORY)}
                            okText="Yes"
                            cancelText="No"
                            disabled={loadingType !== null}
                        >
                            <Button
                                type="primary"
                                danger
                                block
                                loading={loadingType === transactionTypes.INVENTORY}
                                disabled={loadingType !== null}
                            >
                                Remove Inventory Data
                            </Button>
                        </Popconfirm>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default RemoveTransactionData;
